module.exports = __webpack_public_path__ + "static/media/demo1.e2b1b6c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/home/demo1.png
// module id = 696
// module chunks = 2